import { render, staticRenderFns } from "./RewardStatistics.vue?vue&type=template&id=14547a8d"
import script from "./RewardStatistics.vue?vue&type=script&lang=js"
export * from "./RewardStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports